var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fa fa-envelope fa-lg",attrs:{"aria-hidden":"false","title":_vm.uLang('app.resend_invoice')},on:{"click":_vm.resendInvoice}})
}
var staticRenderFns = []

export { render, staticRenderFns }